import commonMixin from './_common';
import flashMessageMixin from './_flash_messages';

/**
 *
 * gaイベントを送信するミックスインオブジェクト
 *
 */
export default {
    mixins: [
        commonMixin,
        flashMessageMixin,
    ],
    methods: {
        /**
         * カスタムイベントを送信
         *
         * 使い方：
         * 新しいイベントを送信する場合、GTM側でイベントトリガーを作成すること。
         * パラメータを増やす場合は、GTMとGA4側での設定が必要。
         *
         * @param $event    // イベント名
         * @param $category // イベントカテゴリ
         * @param $lavel    // イベントラベル
         */
        sendGAEvent: function(event, category = null, label = null) {
            if (window.dataLayer) {
                window.dataLayer.push({
                    'event'          : event,
                    'event_category' : category,
                    'event_label'    : label
                });
            }
        },
        /**
         * カスタムページビューを送信
         *
         * @param $path  //ページパス
         * @param $title //ページタイトル、もしくは識別名(日本語でOK)
         */
        sendGAPageView: function(path, title) {
            if (window.dataLayer) {
                window.dataLayer.push({
                    'event'        : 'custom_page_view',
                    'page_path'    : path,
                    'page_title'   : title,
                });
            }
        },
    }
};